import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { DynamicHomepageService } from "../../../services/dynamic-homepage.service";
import { ContactObject } from "../../utility/ContactObject";
import { LinkObject } from "../../utility/LinkObject";
import { HtmlTextObject } from "../../utility/HtmlTextObject";

@Component({
    selector: "app-confirm-changes-dialog",
    templateUrl: "./confirm-changes-dialog.component.html",
    styleUrls: ["./confirm-changes-dialog.component.scss"],
    standalone: false
})
export class ConfirmChangesDialogComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  sectionType = "";
  columnsToDisplay: any[] = [];
  toDelete: any[] = [];
  toRestore: any[] = [];
  toCreate: any[] = [];

  constructor(
    private homepageService: DynamicHomepageService,
    private dialogRef: MatDialogRef<ConfirmChangesDialogComponent>,
    private changeDetectorRefs: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) obj: any
  ) {
    this.dataSource = new MatTableDataSource();
    this.sectionType = obj.sectionType;
    this.toDelete = obj.toDelete;
    this.toCreate = obj.toCreate;

    this.columnsToDisplay = obj.columnsToDisplay;
    this.columnsToDisplay.shift();
    this.columnsToDisplay.shift();
    this.columnsToDisplay.unshift("restore");
  }

  ngOnInit(): void {
    for (const e of this.toDelete) {
      if (this.sectionType === "contact") {
        this.homepageService.getContactById(e).subscribe((res) => {
          this.dataSource.data.push(res);
          this.dataSource = new MatTableDataSource(this.dataSource.data);
          this.changeDetectorRefs.detectChanges();
        });
      } else if (this.sectionType === "link") {
        this.homepageService.getLinkById(e).subscribe((res) => {
          this.dataSource.data.push(res);
          this.dataSource = new MatTableDataSource(this.dataSource.data);
          this.changeDetectorRefs.detectChanges();
        });
      } else {
        this.homepageService.getHtmlTextById(e).subscribe((res) => {
          this.dataSource.data.push(res);
          this.dataSource = new MatTableDataSource(this.dataSource.data);
          this.changeDetectorRefs.detectChanges();
        });
      }
    }
  }

  save() {
    this.dispatchRequests();
    this.dialogRef.close({ save: true });
  }

  cancel() {
    this.dialogRef.close({
      newDeleteList: this.toDelete,
      toRestore: this.toRestore,
      save: false,
    });
  }

  hasDeletions(): boolean {
    return this.toDelete.length > 0;
  }

  getHeader(column: string) {
    if (column === "displayText") {
      return "DISPLAY TEXT";
    } else if (column === "url" && this.sectionType === "contact") {
      return "IMAGE SOURCE";
    } else if (column === "description" && this.sectionType === "htmlText") {
      return "TEXT";
    } else {
      return column.toUpperCase();
    }
  }

  // Undo deletion by deleting element from delete list and adding to restore list
  undoDelete(e) {
    if (this.toDelete.includes(e.id)) {
      const index = this.toDelete.indexOf(e.id);
      if (index > -1) {
        this.toDelete.splice(index, 1);
      }
    }
    if (!this.toRestore.includes(e)) {
      this.toRestore.push(e);
    }

    this.dataSource.data.splice(this.dataSource.data.indexOf(e), 1);
    this.dataSource._updateChangeSubscription();
    this.changeDetectorRefs.detectChanges();
  }

  // Handles finalizing and sending requests to backend
  dispatchRequests() {
    if (this.toDelete.length > 0) {
      this.toDelete.forEach((value: any, _: any) => {
        this.homepageService.deleteMediaById(value).subscribe((_) => {});
      });
    }

    if (this.toCreate.length > 0) {
      this.toCreate.forEach(
        (value: ContactObject | LinkObject | HtmlTextObject) => {
          if (this.sectionType === "contact") {
            this.homepageService
              .createContact(value as ContactObject)
              .subscribe((_) => {});
          } else if (this.sectionType === "link") {
            this.homepageService
              .createLink(value as LinkObject)
              .subscribe((_) => {});
          } else {
            this.homepageService
              .createHtmlText(value as HtmlTextObject)
              .subscribe((_) => {});
          }
        }
      );
    }
    this.dialogRef.close();
  }
}
